// NCE-Adventkalender
if ($('.ttgNCEAdventkalender').length > 0) {
    // Kindelelemente der 6er Raster (außer dem ersten) in den ersten Raster einfügen
    // $('.grid-6er').each(function(index) {
    //     $('.grid-1-6').append($(this).children());
    //     $(this).children().remove();
    // });

    // // Sortierung nach Datum
    // var $wrapper = $('.grid-1-6');
    // $wrapper.find('.ttgNCEAdventkalender').sort(function(a, b) {
    //     return +a.dataset.sort - +b.dataset.sort;
    // })
    //     .appendTo($wrapper);
    // $wrapper.removeClass('ttg-xxs-12 col-xs-6 col-sm-3 col-md-2 col-lg-2');

    // $('.ttgNCE6erGrid').fadeTo('slow', 1);

    $('body').on('click', '.ttgNCEAdventkalender', function(e) {

        // beim Klick auf die Copyright-Angabe soll die Karte nicht umgedreht werden
        if ($(e.target).closest('.ttgCopyright', '.ttgCopyright button').length) {
            return;
        }

        $(this).find('.card-turn, .no-card-turn').addClass('active');
    });
}
